import { useEffect, useRef, useState } from "react";

// File d'attente idle : après le `load`, les sections se montent une par une
// (une tâche courte à la fois => pas de long task, TBT minimal).
const queue = [];
let draining = false;
const idle = (cb) => (window.requestIdleCallback ? window.requestIdleCallback(cb, { timeout: 1500 }) : setTimeout(cb, 120));

function drain() {
  if (draining) return;
  draining = true;
  const next = () => {
    const fn = queue.shift();
    if (!fn) {
      draining = false;
      return;
    }
    fn();
    idle(next);
  };
  idle(next);
}

let started = false;
let arming = false;
function startAfterLoad() {
  if (started) {
    if (!arming) setTimeout(drain, 1200);
    return;
  }
  started = true;
  arming = true;
  // Démarre la file : à la 1re interaction (scroll/touch/clic), tout de suite si deep-link (#tarifs…),
  // sinon après une fenêtre de calme de ~5,5 s post-load (hors mesure TBT/TTI de PageSpeed).
  const go = () => {
    arming = false;
    ["scroll", "pointerdown", "touchstart", "keydown"].forEach((ev) => window.removeEventListener(ev, go));
    drain();
  };
  ["scroll", "pointerdown", "touchstart", "keydown"].forEach((ev) => window.addEventListener(ev, go, { passive: true, once: true }));
  if (window.location.hash.length > 1) {
    go();
    return;
  }
  const arm = () => setTimeout(go, 5500);
  if (document.readyState === "complete") arm();
  else window.addEventListener("load", arm, { once: true });
}

// Monte ses enfants quand la section approche du viewport, ou via la file idle post-load.
export default function LazyMount({ children, minHeight = "100vh" }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (show) return;
    const el = ref.current;
    const reveal = () => setShow(true);
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          reveal();
          io.disconnect();
        }
      },
      { rootMargin: "600px 0px" }
    );
    if (el) io.observe(el);
    queue.push(reveal);
    startAfterLoad();
    return () => {
      io.disconnect();
      const i = queue.indexOf(reveal);
      if (i >= 0) queue.splice(i, 1);
    };
  }, [show]);

  if (show) return children;
  return <div ref={ref} className="bg-[#0A0A0A]" style={{ minHeight }} aria-hidden="true" />;
}
